"use client";

import { useEffect, useState } from "react";
import type { AiProfile } from "@/types/ai";
import { ensureMindalooProfile } from "./defaultProfile";
import { getUserAIs } from "@/lib/ai/entityManager";
import { entityToAiProfile } from "@/types/aiEntity";

export function useMindalooProfile() {
  const [profile, setProfile] = useState<AiProfile | null>(null);
  const [profiles, setProfiles] = useState<AiProfile[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const core = await ensureMindalooProfile();
        const entities = await getUserAIs();
        const list = [core, ...entities.map(entityToAiProfile).filter((p) => p.id !== core.id)];
        if (!cancelled) {
          setProfile(core);
          setProfiles(list);
        }
      } catch (e) {
        console.error("[Mindaloo] profile load failed", e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { profile, profiles, loading };
}
